import * as ScrollArea from "@radix-ui/react-scroll-area";

export const SidebarScrollArea: FCWithChildren = ({ children }) => (
  <ScrollArea.Root
    type="hover"
    className="relative min-h-0 w-full flex-1 overflow-hidden box-border!"
  >
    <ScrollArea.Viewport className="h-full w-full box-border! [&>div]:block!">
      {children}
    </ScrollArea.Viewport>
    <ScrollArea.Scrollbar
      orientation="vertical"
      className="flex w-1.5 touch-none p-px select-none box-border!"
    >
      <ScrollArea.Thumb className="relative flex-1 rounded-[3px] bg-[#637A88] opacity-60 hover:opacity-100" />
    </ScrollArea.Scrollbar>
  </ScrollArea.Root>
);
